import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInLogin } from '../http/userAPI';
import { Context } from '..';
import { observer } from 'mobx-react-lite';

const Auth = observer(() => {
    const { user } = useContext(Context);
    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();

    const signIn = async () => {
        if (!login.trim() || !password.trim()) {
            alert('Please fill in all fields');
            return;
        }

        setLoading(true);
        try {
            const data = await signInLogin(login, password);
            user.setUser(data);
            user.setIsAuth(true);
            navigate(data.role === 'ADMIN' ? '/admin' : '/');
        } catch (error) {
            alert(error.response?.data?.message || 'Login failed');
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        signIn();
    };

    return (
        <div className='centered' style={{ height: '100vh', alignItems: 'center' }}>
            <div className='auth-form'>
                <h1>Authorization</h1>
                <form onSubmit={handleSubmit}>
                    <div>
                        <label htmlFor="login">Username:</label>
                        <input
                            id="login"
                            placeholder='Enter username'
                            value={login}
                            onChange={e => setLogin(e.target.value)}
                            disabled={loading}
                        />
                    </div>
                    <div>
                        <label htmlFor="password">Password:</label>
                        <input
                            id="password"
                            placeholder='Enter password'
                            type={showPassword ? 'text' : 'password'}
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            disabled={loading}
                        />
                        <button 
                            type="button" 
                            onClick={() => setShowPassword(!showPassword)}
                            disabled={loading}
                        >
                            {showPassword ? 'Hide' : 'Show'}
                        </button>
                    </div>
                    <button type="submit" disabled={loading}>
                        {loading ? 'Logging in...' : 'Login'}
                    </button>
                </form>
            </div>
        </div>
    );
});

export default Auth;